export default __webpack_public_path__ + "static/platinum-solution-partner-white-34d24664a0944b464edcafccabe42abe.png";